import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-38",
  "use": "icon-38-usage",
  "viewBox": "0 0 15 13.635",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 13.635\" id=\"icon-38\"><defs><style> </style></defs><g transform=\"translate(-76 -188)\"><path class=\"a\" d=\"M76,199.818H91v1.817H76Zm11.625-5.232-3.306,3.105a1.218,1.218,0,0,1-.82.308,1.193,1.193,0,0,1-.818-.311l-3.308-3.1a.87.87,0,0,1-.284-.622,1.029,1.029,0,0,1,1.1-.93h.025v-.005H82.4v-2.282a1.119,1.119,0,0,1,2.206,0v2.282h2.141v.008l.064,0a1.029,1.029,0,0,1,1.1.93.853.853,0,0,1-.286.621ZM81.735,188h3.53v5.454h-3.53Zm0,0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol